import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

export const useArticleCategoryList = () => {
  const [ArticleCategoryListLoading, setArticleCategoryListLoading] = useState(false);
  const [ArticleCategoryList, setArticleCategoryList] = useState([]);

  const getArticleCategoryList = useCallback(async () => {
    setArticleCategoryListLoading(true);
    const res = await request({
      path: "article-category/list",
    });
    setArticleCategoryList(res?.data);
    setArticleCategoryListLoading(false);
    return res?.data;
  }, []);

  useEffect(() => {
    getArticleCategoryList();
  }, []);

  return { ArticleCategoryListLoading, ArticleCategoryList, getArticleCategoryList };
};
